import { render, staticRenderFns } from "./RoutePlan.vue?vue&type=template&id=bfd48014&scoped=true"
import script from "./RoutePlan.vue?vue&type=script&lang=js"
export * from "./RoutePlan.vue?vue&type=script&lang=js"
import style0 from "./RoutePlan.vue?vue&type=style&index=0&id=bfd48014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd48014",
  null
  
)

export default component.exports